import type {
  G_VideoViewingExpiration,
  G_VideoRentalViewingExpiration,
  G_VideoLegacyViewingExpiration,
  G_VideoFixedViewingExpiration,
  Maybe,
} from "~/lib/graphql";

export const isVideoRentalViewingExpiration = (
  viewingExpiration?: Maybe<G_VideoViewingExpiration>
): viewingExpiration is G_VideoRentalViewingExpiration => {
  if (viewingExpiration === undefined || viewingExpiration === null) return false;
  return "startLimitDay" in viewingExpiration || "expireHour" in viewingExpiration;
};

export const isVideoLegacyViewingExpiration = (
  viewingExpiration?: Maybe<G_VideoViewingExpiration>
): viewingExpiration is G_VideoLegacyViewingExpiration => {
  if (viewingExpiration === undefined || viewingExpiration === null) return false;
  return "expireDay" in viewingExpiration;
};

export const isVideoFixedViewingExpiration = (
  viewingExpiration?: Maybe<G_VideoViewingExpiration>
): viewingExpiration is G_VideoFixedViewingExpiration => {
  if (viewingExpiration === undefined || viewingExpiration === null) return false;
  return "expiresAt" in viewingExpiration;
};
